define('views/shop/shop',[
	'views/_base/baseview',
	'text!views/shop/shop.html',
	'text!views/shop/instore_template.html',
	'text!views/shop/online_template.html',
	'views/shop/instore/instore_preview',
	'views/shop/online/online_preview',
	'models/search/searchresult_collection',
	'views/shop/instore/merchant',
	'views/shop/online/merchant',
	'views/shop/google_map',
	'models/linkedcards/linkedcard_collection',
	'models/shared/lookups/lookups',
	'views/shop/search/search',
	'views/shop/travel/hotels',
], function (
	BaseView,
	ShopTemplate,
	InstoreTemplate,
	OnlineTemplate,
	InstorePreview,
	OnlinePreview,
	MerchantSearchModel,
	NearbyMerchantView,
	OnlineMerchantView,
	GoogleMap,
	LinkedCardsModel,
	LookupsModel,
	SearchComponent,
	HotelsView
) {
	'use strict';

	return BaseView.extend({
		id: 'shop-container',
		tagName: 'div',
		className: 'msg-nl-available',
		isRender: true,

		// Events
		events: {
			click: 'stopLoad',
		},

		// Templates
		template: _.template(ShopTemplate),
		instore_template: _.template(InstoreTemplate),
		online_template: _.template(OnlineTemplate),

		// General Configurations
		focused: null, // BOOLEAN : Controls the overall page and component display
		type: 1, // ENUM/INT: Control which view is displayed, nearby vs. online (refers to enums.merchantLocationTypes; nearby is default)
		page_size: 40, // INT     : How many results per page
		radius: 25, // INT     : Search radius (in miles)
		zipcode: null, // STRING  : Zip code used for local merchant search
		list_end: false, // BOOLEAN : End of scrollable list
		nearby_loaded: false, // BOOLEAN : For checks on whether nearby has been added to the dom
		online_list_end: false,
		online_loaded: false,
		location_preference: 1, // ENUM/INT: merchantLocationPreference - Current: 1, Search: 2, Zipcode: 3
		reset_map: false,

		// Slider Configurations
		animate_time: 300,
		merchant_width: 221,
		merchant_list_width: 2210,

		initialize: function (options) {
			options = options || {};

			// Make options available to entire view
			this.options = options ? options : {};

			// Sync all presets before we Render or Load
			this.syncPresets();

			// Listen to window scroll event for endless scroll
			this.window = $(window);
			this.online_window = $(window);

			_.bindAll(this, 'checkScroll');
			_.bindAll(this, 'checkOnlineScroll');

			this.elementName = options.elementName;

			BaseView.prototype.initialize(this);
		},

		syncPresets: function () {
			// Check to see is if focused (typically will come from router if set here)
			if (this.options.focused) {
				this.focused = true;
			} else {
				this.focused = false;
			}

			// Check to see if the type exists within the URL
			if (this.options.type) {
				this.type = this.options.type;
			}
		},

		render: function () {
			var that = this;

			if (!pf.session.get('auth')) {
				this.$el.addClass('logged_out');
			}

			this.$el.html(this.template());

			// Init Search Component
			this.search_component = new SearchComponent({
				elementName: '.js-merchant-search-container',
				shop: this,
				options: this.options,
			});

			// Init Online Search Component
			this.online_search_component = new SearchComponent({
				elementName: '.js-online-merchant-search-container',
				shop: this,
				options: this.options,
				online: true,
			});

			// Check for linked cards
			this.checkForNotifications();

			// Enable scroll listener, delay is set to allow dom to render
			setTimeout(function () {
				that.enableCheckScroll();
			}, 1000);

			setTimeout(function () {
				that.enableOnlineCheckScroll();
			}, 2000);

			return this;
		},

		goToAccounts: function () {
			pf.navigate('linkedaccounts');
		},

		stopLoad: function () {
			console.log('%cSTOP LOAD - SHOP', 'color: rebeccapurple');
			return false;
		},

		checkForNotifications: function () {
			// if(pf.session.get('auth') && this.focused){
			if (pf.session.get('auth')) {
				var that = this,
					has_linkedcard = false;

				this.linkedcards = new LinkedCardsModel({
					instanceURL: pf.consumerURL + '/LinkedCards',
				});

				this.linkedcards
					.fetch({
						data: { smc: true },
					})
					.done(function () {
						if (that.linkedcards.length > 0) {
							that.linkedcards.forEach(function (card) {
								if (card.CardTypeID == 1 || card.CardTypeID == 2) {
									has_linkedcard = true;
								}
							});

							if (!has_linkedcard) {
								that.$('#shop-banner-container').slideDown();
							} else {
								that.$('#shop-banner-container').hide();
							}
						}
					})
					.fail(function () {});
			}
		},

		loadData: function () {},

		/*
            Shop Nearby Merchants
        */

		getNearbyMerchants: function (loading_more) {
			var that = this;

			// If deeplink, override with merchant search
			if (this.options.merchant_guid) {
				this.search_component.nearby_data.mgguid = this.options.merchant_guid;
			}

			// Update scroll checking variables
			this.list_end = false;
			this.merchants_loading = true;

			this.nearby_merchants = new MerchantSearchModel({
				instanceURL: pf.merchantsSearchURL,
				pageSize: this.page_size,
			});

			this.nearby_merchants
				.fetch({
					type: 'GET',
					data: this.search_component.nearby_data,
					contentType: 'application/json',
				})
				.done(function (model, resp) {
					if (!that.search_component.nearby_loaded && !that.map_container) {
						that.addMap();
					} else if (that.map_container) {
						if (loading_more) {
							that.updateMap({ loading_more: true });
						} else {
							that.updateMap({ loading_more: false });
						}
					}

					// Only call once
					if (!that.search_component.nearby_loaded) {
						that.addNearbyMerchantsView();

						that.addNearbyMerchantsPreview(that.nearby_merchants);
					} else {
						that.addNearbyMerchants();
					}

					// if(that.reset_map){
					if (
						that.search_component.location_preference ==
							enums.merchantLocationPreference.Zipcode &&
						that.focused &&
						!loading_more
					) {
						setTimeout(function () {
							google.maps.event.trigger(pf.maps.current, 'resize');

							// Set center of the map with the location of first merchant
							if (that.nearby_merchants.length) {
								var location = that.nearby_merchants.toJSON()[0].Location,
									lat = location.slice(0, location.indexOf(',')),
									lon = location.slice(location.indexOf(',') + 1),
									center = { LAT: lat, LON: lon };

								if (that.map_container) {
									that.map_container.updateLocation(center);
									that.map_container.centerMap();
								}
							}
						}, 3000);
					}

					// If they merchant results are less that what we asked for, then disable scroll checking
					if (that.nearby_merchants.length < that.page_size) {
						// Update scroll checking variables
						that.disableCheckScroll();
					} else if (that.nearby_merchants.length >= that.page_size) {
						// Allow new merchants to render in the dom
						setTimeout(function () {
							that.enableCheckScroll();
						}, 1500);
					}

					// Update scroll checking variables and list
					that.merchants_loading = false;

					// that.$('.js-merchant-list-inner-container').animate({
					//     scrollTop: (0)
					// }, 0);

					// console.log('nearby_merchants',that.nearby_merchants.length,that.page_size, that.merchants_loading);

					// TODO: If there are no results, show message

					if (!that.search_component.nearby_loaded) {
						that.search_component.nearby_loaded = true;
						// that.search_component.search_component.nearby_loaded = true;
					}
				})
				.fail(function (resp, status, err) {
					// TODO: Handle errors
					if (resp.status == 404) {
						// TODO: If there are no results, show message

						// By not sending false, the map will automatically clear all markers
						that.updateMap({ loading_more: false });

						// Update scroll checking variables and list
						that.merchants_loading = false;

						that.$('.js-merchant-list-inner-container').animate(
							{
								scrollTop: 0,
							},
							0
						);
					}
				});
		},

		removeNearbyMerchants: function () {
			this.$('.js-merchant-list').html('');
			// TODO: Fix this, it's not updating/removing Markers
			this.updateMap({ loading_more: false });
		},

		addNearbyMerchantsPreview: function (collection) {
			var merchant_instore_preview = new InstorePreview({
				collection: collection,
				calling_view: this,
			});
			this.$el
				.find('#shop-instore-preview-container')
				.append(merchant_instore_preview.el);
		},

		seeMoreClickFromPreview: function () {
			this.reset_map = true;
		},

		addNearbyMerchantsView: function () {
			this.$('#shop-instore-full-container').html(this.instore_template());
			this.addNearbyMerchants();
		},

		addNearbyMerchants: function () {
			var that = this;

			this.nearby_merchants.forEach(function (merchant) {
				var merchant_list_item = new NearbyMerchantView({
					data: merchant,
					map: that.map_container,
				});

				that.$('.js-merchant-list').append(merchant_list_item.el);
			});
		},

		updateNearbyMerchants: function () {},

		updateOnlineMerchants: function () {},

		addMap: function () {
			var that = this,
				data = {};

			data = this.search_component.nearby_data;

			// Initiate the map view
			this.map_container = new GoogleMap({
				search_data: data,
				locations: this.nearby_merchants.models,
				view: 'merchants',
				parentView: this,
			});

			setTimeout(function () {
				that.$('.merchant-map-container').html(that.map_container.el);
			}, 1500);
		},

		updateMap: function (data) {
			var current_location = this.search_component.nearby_data;

			if (this.map_container) {
				this.map_container.updateLocation(current_location);
				this.map_container.updateMap(this.nearby_merchants.models, data);
			}
		},

		onMerchantMapHover: function (model) {
			// Add hover class to this merchant
			// console.log('SHOP - onMerchantMapHover',model);
		},

		/*
            Shop Online Merchants
        */

		getOnlineMerchants: function (loading_more) {
			var that = this;

			// Update scroll checking variables
			this.online_list_end = false;
			this.online_merchants_loading = true;

			this.online_merchants = new MerchantSearchModel({
				instanceURL: pf.merchantsSearchURL,
				pageSize: this.page_size,
			});

			this.online_merchants
				.fetch({
					type: 'GET',
					data: this.online_search_component.online_data,
					contentType: 'application/json',
				})
				.done(function (model, resp) {
					// Only call once
					if (!that.online_search_component.online_loaded) {
						that.addOnlineMerchantsView();

						that.addOnlinePreviewMerchants();

						that.online_search_component.online_loaded = true;
						// that.online_search_component.online_search_component.online_loaded = true;
					} else {
						// console.log('online search',loading_more,resp);

						if (!loading_more) {
							that.$('.js-merchant-online-list').empty();
						}

						that.addOnlineMerchants();
					}

					// If they merchant results are less that what we asked for, then disable scroll checking
					if (that.online_merchants.length < that.page_size) {
						// Update scroll checking variables
						that.disableOnlineCheckScroll();
					} else if (that.online_merchants.length >= that.page_size) {
						// Allow new merchants to render in the dom
						setTimeout(function () {
							that.enableOnlineCheckScroll();
						}, 1500);
					}

					setTimeout(function () {
						// Update scroll checking variables and list
						that.online_merchants_loading = false;
						that.enableOnlineCheckScroll();
					}, 2000);

					// Update scroll checking variables and list
					// that.online_merchants_loading = false;

					// return false;

					// that.$('.js-merchant-online-list').animate({
					//     scrollTop: that.online_window.scrollTop
					// }, 0);
				})
				.fail(function (resp, textStatus, err) {
					if (resp.status == 404) {
						// Update scroll checking variables and list
						that.online_merchants_loading = false;
					}
				});
		},

		removeOnlineMerchants: function () {
			this.$('.js-merchant-online-list').html('');
		},

		addOnlineMerchantsView: function () {
			this.$('#shop-online-full-container').html(this.online_template());
			this.addOnlineMerchants();
		},

		addOnlineMerchants: function () {
			var that = this;

			if (this.online_merchants.length == 0) {
				this.$('.js-merchant-online-list').html('No results found');
			} else {
				this.online_merchants.forEach(function (merchant) {
					var online_merchant_list_item = new OnlineMerchantView({
						data: merchant,
					});

					that
						.$('.js-merchant-online-list')
						.append(online_merchant_list_item.el);
				});
			}
		},

		addOnlinePreviewMerchants: function () {
			var merchant_online_preview = new OnlinePreview({
				collection: this.online_merchants,
				calling_view: this,
			});
			this.$el
				.find('#shop-online-preview-container')
				.append(merchant_online_preview.el);
		},

		/*
            Shop Event Functions
        */

		loadMoreMerchants: function () {
			if (this.type == enums.merchantLocationTypes.Online) {
				this.online_search_component.online_data.start =
					Number(this.online_search_component.online_data.start) +
					Number(this.online_search_component.online_data.c);

				this.getOnlineMerchants(true);
			} else if (this.type == enums.merchantLocationTypes.Store) {
				this.search_component.nearby_data.start =
					Number(this.search_component.nearby_data.start) +
					Number(this.search_component.nearby_data.c);

				this.getNearbyMerchants(true);
			}
		},

		handleHeaderClick: function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			if (e && e.stopPropagation) {
				e.stopPropagation();
			}

			if (!this.focused) {
				pf.navigate('shop');
			}
		},

		showFullMerchantView: function () {
			if (!this.focused) {
				// Ensure the shop view is open
				this.toggleShopView();
				pf.navigate('shop', { trigger: false });
			}
		},

		showFullMerchantViewSearch: function () {
			if (!this.focused) {
				// Ensure the shop view is open
				this.toggleShopView();
				pf.navigate('shop', { trigger: false });

				// TODO: Launch mobile search view
			}
		},

		/*
            Shop Slider Functions
        */

		enablePreviewSlider: function () {
			this.$el.find('.slider-next-btn').addClass('show');
		},

		showNextInstorePreviewMerchants: function () {
			this.animateList('next', 'instore');
		},

		showPreviousInstorePreviewMerchants: function () {
			this.animateList('previous', 'instore');
		},

		showNextOnlinePreviewMerchants: function () {
			this.animateList('next', 'online');
		},

		showPreviousOnlinePreviewMerchants: function () {
			this.animateList('previous', 'online');
		},

		resetPreview: function () {
			this.$el.find('#shop-instore-list-container').css({ marginLeft: '0px' });
			this.$el.find('.js-shop-preview-previous').removeClass('show');
			this.$el.find('.js-shop-preview-next').addClass('show');

			this.$el.find('#shop-online-list-container').css({ marginLeft: '0px' });
			this.$el.find('.js-online-preview-previous').removeClass('show');
			this.$el.find('.js-online-preview-next').addClass('show');
		},

		animateList: function (direction, temp_view) {
			var list = this.$el.find('#shop-' + temp_view + '-list-container'),
				list_container = this.$el.find(
					'#shop-' + temp_view + '-preview-container'
				),
				next_btn =
					temp_view == 'instore'
						? list_container.find('.js-shop-preview-next')
						: list_container.find('.js-online-preview-next'),
				previous_btn =
					temp_view == 'instore'
						? list_container.find('.js-shop-preview-previous')
						: list_container.find('.js-online-preview-previous'),
				preview_width = list_container.width(),
				list_width = this.merchant_width * 10,
				current_offset = Math.abs(parseInt(list.css('marginLeft'))),
				offset =
					direction == 'next'
						? preview_width + current_offset
						: current_offset - preview_width;

			if (
				(direction == 'next' && offset <= list_width) ||
				(direction == 'previous' && offset >= 0)
			) {
				list.animate({ marginLeft: '-' + offset + 'px' }, this.animate_time);

				if (offset + preview_width > list_width) {
					next_btn.removeClass('show');
				} else if (offset + preview_width < list_width) {
					next_btn.addClass('show');
				}

				if (offset > 0) {
					previous_btn.addClass('show');
				} else if (offset - preview_width < 0) {
					previous_btn.removeClass('show');
				}
			}
		},

		/*
            Shop Toggle Functions
        */

		toggleShopView: function () {
			if (this.focused) {
				this.$el.removeClass('focused');
				this.focused = false;
			} else {
				this.$el.addClass('focused');
				this.focused = true;
			}

			this.handleShopViewToggle();
		},

		handleNearbyToggle: function () {
			var map = this.$('.js-merchant-map-container'),
				map_icon = this.$('.js-merchant-toggle-nearby-map'),
				list = this.$('.js-merchant-list-inner-container'),
				list_icon = this.$('.js-merchant-toggle-nearby-list');

			if (map_icon.is(':visible')) {
				map_icon.fadeOut(150, function () {
					list_icon.fadeIn(300);
				});

				list.fadeOut(300, function () {
					map.fadeIn();
				});
			} else {
				list_icon.fadeOut(150, function () {
					map_icon.fadeIn(300);
				});

				map.fadeOut(300, function () {
					list.fadeIn();
				});
			}
		},

		handleShopViewToggle: function (e) {
			if (e && e.preventDefault) {
				e.preventDefault();
			}
			if (e && e.stopPropagation) {
				e.stopPropagation();
			}

			var merchant_type = e ? $(e.target).data('link') : this.type;

			this.type = merchant_type;

			$('.merchant-links li a').removeClass('active');

			$('.merchant-links li a[data-link=' + this.type + ']').addClass('active');

			if (this.focused) {
				if (this.type == enums.merchantLocationTypes.Online) {
					pf.navigate('shop/online', { trigger: false });
				} else if (this.type == enums.merchantLocationTypes.Store) {
					pf.navigate('shop/nearby', { trigger: false });
				} else if (this.type == enums.merchantLocationTypes.Travel) {
					pf.navigate('shop/travel', { trigger: false });
				}

				this.toggleMerchantType(
					'#shop-instore-full-container',
					'#shop-online-full-container'
				);
			} else {
				this.toggleMerchantType(
					'#shop-instore-preview-container',
					'#shop-online-preview-container'
				);
			}
		},

		toggleMerchantType: function (instore_merchants, online_merchants) {
			var that = this;

			if (this.type == enums.merchantLocationTypes.Online) {
				// Add active class to online toggle button
				// this.$el.find('.merchant-toggle-online-placeholder').addClass('active');

				if (this.focused) {
					this.$el.find('#shop-online-list-container').hide();
				}

				// Hide Search Merchants form
				this.search_component.$el.hide();

				// Hide Mobile Nearby Toggle
				this.$el.find('.js-merchant-toggle-nearby').addClass('hidden');

				// Show Online Explanation
				this.$el.find('.js-shop-online-explanation').fadeIn();

				this.$el.find('#shop-hotels-full-container').fadeOut(300);
				this.$el.find(instore_merchants).fadeOut(300);

				setTimeout(function () {
					// Show Online Search Merchants form
					that.online_search_component.$el.show();

					// Show online merchants after instore fades out completely
					that.$el.find(online_merchants).fadeIn();

					// If Online merchants haven't loaded, then load here
					if (
						!that.online_search_component.online_loaded &&
						!that.online_loaded
					) {
						that.online_loaded = true;
						that.nearby_loaded = false;

						that.getOnlineMerchants();
					}
				}, 300);
			} else if (this.type == enums.merchantLocationTypes.Store) {
				// Add active class to instore toggle button
				// this.$el.find('.merchant-toggle-nearby-placeholder').addClass('active');

				if (this.focused) {
					this.$el.find('#shop-instore-list-container').hide();
				}

				// Hide Online Search Merchants form
				if (this.online_search_component) {
					this.online_search_component.$el.hide();
				}

				// Show Mobile Nearby Toggle
				this.$el.find('.js-merchant-toggle-nearby').removeClass('hidden');

				// Hide Online Explanation
				this.$el.find('.js-shop-online-explanation').fadeOut();

				this.$el.find('#shop-hotels-full-container').fadeOut(300);
				this.$el.find(online_merchants).fadeOut(300);

				setTimeout(function () {
					// Show instore merchants after online fades out completely
					that.$el.find(instore_merchants).fadeIn();

					// Show Search Merchants form
					that.search_component.$el.show();

					// If Nearby merchants haven't loaded, then load here
					if (!that.search_component.nearby_loaded && !that.nearby_loaded) {
						that.nearby_loaded = true;
						that.online_loaded = false;

						that.getNearbyMerchants();
					}
				}, 300);
			} else if (this.type == enums.merchantLocationTypes.Travel) {
				this.online_loaded = false;
				this.nearby_loaded = false;

				// Hide Online Search Merchants form
				this.online_search_component.$el.hide();

				// Hide Search Merchants form
				this.search_component.$el.hide();

				// Hide Mobile Nearby Toggle
				this.$el.find('.js-merchant-toggle-nearby').addClass('hidden');

				// Hide Online Explanation
				this.$el.find('.js-shop-online-explanation').fadeOut();

				this.$el.find(instore_merchants).fadeOut(300);
				this.$el.find(online_merchants).fadeOut(300);

				setTimeout(function () {
					var hotels_view = new HotelsView({});
					that.$el.find('#shop-hotels-full-container').html(hotels_view.el);
					that.$el.find('#shop-hotels-full-container').fadeIn();
				}, 300);
			}
		},

		/*
            Shop Utility Functions
        */

		clearDeeplink: function () {
			// Clear any deeplink merchant searches by nulling merchant_guid
			if (this.options.merchant_guid) {
				this.options.merchant_guid = null;
			}
		},

		/*
            Shop Merchant Infinite Scroll Functions
        */

		enableOnlineCheckScroll: function () {
			this.$('#shop-online-full-container').on(
				'scroll',
				this.checkOnlineScroll
			);
		},

		disableOnlineCheckScroll: function () {
			this.online_list_end = true;
			this.$('#shop-online-full-container').off(
				'scroll',
				this.checkOnlineScroll
			);
		},

		checkOnlineScroll: function () {
			if (
				!this.online_merchants_loading &&
				!this.online_list_end &&
				this.$('.js-merchant-online-list').is(':visible')
			) {
				var container = this.$('#shop-online-full-container'),
					container_bottom = container.height() + container.offset().top,
					merchant_list = this.$('.js-merchant-online-container'),
					merchant_list_bottom =
						merchant_list.height() + merchant_list.offset().top,
					trigger_offset = 500;

				if (container_bottom > merchant_list_bottom - trigger_offset) {
					this.loadMoreMerchants();
				}
			}
		},

		enableCheckScroll: function () {
			this.window.on('scroll', this.checkScroll);
			this.$('.js-merchant-list-inner-container').on(
				'scroll',
				this.checkScroll
			);
		},

		disableCheckScroll: function () {
			this.list_end = true;
			this.window.off('scroll', this.checkScroll);
			this.$('.js-merchant-list-inner-container').off(
				'scroll',
				this.checkScroll
			);
		},

		checkScroll: function () {
			if (
				this.merchants_loading == false &&
				this.list_end == false &&
				this.$('.js-merchant-list').is(':visible')
			) {
				var list_bottom =
						this.$('.js-merchant-list').offset().top +
						this.$('.js-merchant-list').height(),
					last_merchant = this.$('.js-merchant-list').find('.merchant').last(),
					last_merchant_bottom =
						last_merchant.offset().top + last_merchant.height(),
					trigger_offset = 1000;

				// Determines which checkscroll logic to use
				if (last_merchant_bottom > list_bottom) {
					// Fixed-height list scrolling
					if (last_merchant_bottom - list_bottom < trigger_offset) {
						// console.log('checkscroll load more --> Fixed height');
						this.loadMoreMerchants();
					}
				} else {
					// Page scrolling
					var window_height = this.window.height(),
						window_bottom = this.window.scrollTop() + this.window.height(),
						trigger_point =
							this.$('.js-merchant-list').offset().top +
							this.$('.js-merchant-list').height() -
							trigger_offset;

					if (
						window_bottom > trigger_point ||
						($(document).height() == window_height &&
							window_height == window_bottom)
					) {
						// console.log('checkscroll load more --> Page scrolling');
						this.loadMoreMerchants();
					}
				}
			}
		},

		toggleGC: function (e) {
			if (e) {
				e.preventDefault();
			}

			var target = $(e.currentTarget),
				toggleText = $('#toggle-text'),
				content = target.prev();

			target.toggleClass('active');

			toggleText.text((index, text) =>
				text === 'view details' ? 'hide details' : 'view details'
			);

			content.css(
				'maxHeight',
				parseInt(content.css('maxHeight'), 10)
					? 0
					: content.get(0).scrollHeight + 'px'
			);
		},

		close: function () {
			// console.log('closing shop view',this.focused);
		},
	});
});

